module.exports = __webpack_public_path__ + "static/naturalist-01-bdc68a48f004aab8229247e35d502d4f.png";